import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 1;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const StatusContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 1;
  gap: ${Spacing.S16};
  justify-content: center;
  width: 40%;
  max-width: 440px;
  height: 100%;
`

export const IllustrationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;

  svg {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
`
